<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_REPORT_STOCK_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      is-list
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <!-- <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessReportStockOut.querySpu')" prop="querySpu">
            <BjInput
              v-model="queryParams.querySpu"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col> -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
            <BjInput
              v-model="queryParams.skuCode"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('goodsPage.skuCode')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'stockoutOrderQty'">
                <span class="link" @click="go(scope.row)">{{ scope.row[col.prop] }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import { BUSINESS_REPORT_STOCK_ROUTE_LIST } from '@/utils/constants';
export default {
  name: 'BusinessReportStockOutIndex',
  components: {},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      selection: false,
      BUSINESS_REPORT_STOCK_ROUTE_LIST,
      queryApi: orderApi.getOrderStatsStockout,
      // 查询参数
      // 已核对字段
      queryParams: {
        querySpu: null,
        skuCode: null,
      },
      labelsVersion: 11,
      labelList: [
        // { label: 'goodsPage.spuName', prop: 'spuName', isCheck: true, disabled: false },
        // { label: 'goodsPage.spuCode', prop: 'spuCode', isCheck: true, disabled: false },
        { label: 'goodsPage.skuCode', prop: 'skuCode', isCheck: true, disabled: false },
        { label: 'BusinessReportStockOut.stockoutOrderQty', prop: 'stockoutOrderQty', isCheck: true, disabled: false },
        {
          label: 'BusinessReportStockOut.stockoutGoodsQty',
          prop: 'stockoutGoodsQty',
          isCheck: true,
          disabled: false,
        },
        {
          label: 'BusinessReportStockOut.usableQty',
          prop: 'usableQty',
          isCheck: true,
          disabled: false,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      return new Promise(resolve => {
        resolve();
      });
    },
    go(row) {
      this.$router.push({ name: 'BusinessOrderShort', query: { skuCode: row.skuCode } });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
